// React
import { useEffect, useState } from "react"
import { SuccessFetch } from "types"

// Utils
import { getBasenamePath, useApi } from "utils"

// Types
interface Type {
  address: string | null
  email: string | null
  phone: string | null
  website: string | null
}
interface SubdomainType {
  logo: string | null
}
interface FetchType extends SubdomainType {
  setting: Type
}

export function useSubdomainSetting(): {
  data: Type | null
  dataCompany: SubdomainType | null
  isLoading: boolean
} {
  // Vars
  const { companyName } = getBasenamePath()

  // Hooks
  const api = useApi()
  const [data, setData] = useState<Type | null>(null)
  const [dataCompany, setDataCompany] = useState<SubdomainType | null>(null)
  const [isLoading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    api.get(
      `/companies/subdomain/${companyName}`
    ).then((res: SuccessFetch<{
      payload: FetchType
    }>) => {
      setDataCompany(res.data.payload)
      setData(res.data.payload.setting)
    }).catch(() => {
      setData(null)
    }).finally(() => {
      setLoading(false)
    })

    return () => {
      setData(null)
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  return { data, dataCompany, isLoading }
}